module.exports = __webpack_public_path__ + "static/media/me.deec776d.jpg";